<template>
  <div class="container-fluid" id="rfp-container">
    <div class="row">
      <div class="col-lg-12">
        <div
          class="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-2"
        >
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="font-weight-bold">{{ titleText }}</h4>
          </div>
          <div class="create-workform">
            <div
              class="d-flex flex-wrap align-items-center justify-content-between"
            >
              <div class="d-flex display-search align-items-center">
                <div class="mr-2 search-input">
                  <search
                    :search="search"
                    :placeholder="'Search'"
                    @searchFilter="handleSearchRFP"
                    v-model="search"
                  >
                  </search>
                  <p class="search-css">
                    Search by RFP number, order number, car vin, car model
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="card card-block card-stretch">
              <div class="card-body-2">
                <div
                  class="mb-2 d-flex flex-wrap align-items-center justify-content-between"
                >
                  <h5>RFP List</h5>
                  <div class="d-flex flex-wrap mt-2 mobile-align-rfp">
                    <div class="sorting-div">
                      <sortingText
                        :sortingData="sortingData"
                        :sorting="sorting"
                        @changeSorting="onChangeSorting"
                      ></sortingText>
                    </div>

                    <div class="d-flex">
                      <div class="ml-2 filter-div">
                        <button
                          class="btn btn-primary btn-sm d-flex align-items-center"
                          @click="filterClick()"
                          v-on:click="showFilters = !showFilters"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="mr-1"
                            width="15"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                          </svg>
                          <div class="notify">
                            Filters
                            <div class="badge" v-if="countFilter">
                              <div class="message-count">{{ countFilter }}</div>
                            </div>
                          </div>
                        </button>
                      </div>

                      <div class="ml-2">
                        <button
                          class="btn btn-warning btn-sm d-flex align-items-center reset-btn-padding-onlist"
                          @click="resetFilters"
                          title="Reset Filters"
                        >
                          <svg
                            version="1.0"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 1280.000000 1266.000000"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <g
                              transform="translate(0.000000,1266.000000) scale(0.100000,-0.100000)"
                              fill="white"
                              stroke="none"
                            >
                              <path
                                d="M6130 12653 c-1136 -47 -2253 -397 -3200 -1002 -1163 -744 -2048
                            -1830 -2525 -3096 -433 -1150 -520 -2406 -249 -3595 169 -740 463 -1430 880
                            -2063 765 -1161 1874 -2034 3189 -2509 977 -354 2044 -467 3080 -328 1388 186
                            2694 829 3675 1810 129 129 1201 1318 1207 1339 2 8 -1951 1746 -1964 1746 -5
                            0 -200 -214 -433 -475 -596 -668 -655 -732 -782 -847 -599 -539 -1284 -857
                            -2083 -964 -292 -39 -726 -36 -1025 7 -1069 153 -1996 719 -2605 1589 -746
                            1066 -863 2457 -305 3632 359 755 979 1375 1745 1744 387 186 728 287 1180
                            351 213 29 712 33 927 5 649 -82 1206 -288 1723 -638 269 -182 481 -372 781
                            -704 153 -168 162 -181 146 -196 -9 -9 -287 -254 -617 -544 -330 -291 -601
                            -532 -603 -537 -2 -4 4 -8 13 -8 8 0 305 -68 658 -150 353 -83 851 -200 1107
                            -260 256 -60 726 -170 1045 -245 319 -75 831 -195 1138 -267 307 -71 560 -128
                            562 -126 3 2 -47 960 -110 2129 -63 1168 -119 2221 -126 2339 -6 118 -14 245
                            -17 282 l-7 67 -520 -459 c-286 -252 -522 -459 -525 -459 -3 -1 -66 67 -140
                            150 -194 219 -425 458 -575 595 -1250 1147 -2934 1759 -4645 1687z"
                              />
                            </g>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <transition name="slide-fade">
                  <div class="row d-flex pb-5 pr-5 pl-5" v-if="showFilters">
                    <div class="col-md-3 filter-tabs">
                      <label
                        for="car-make"
                        class="form-label text-muted filter-label-heading mt-3"
                        >From Date (Date Created)</label
                      >
                      <b-input-group
                        :class="{
                          borderColorFilter: gte !== null ? true : false,
                        }"
                      >
                        <b-form-datepicker
                          id="datepicker-from-date"
                          v-model="gte"
                          size="sm"
                          calendar-width="100%"
                          placeholder="Select"
                          :class="{ singleOptions: true }"
                          @context="onContext"
                          @input="onChangeFromDate($event)"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                          }"
                        >
                        </b-form-datepicker>
                        <template v-slot:append>
                          <button
                            class="filter-cross-btn"
                            @click="removeFromDate()"
                          >
                            x
                          </button>
                        </template>
                      </b-input-group>
                    </div>
                    <div class="col-md-3 filter-tabs">
                      <label
                        for="car-make"
                        class="form-label text-muted filter-label-heading mt-3"
                        >To Date (Date Created)</label
                      >
                      <b-input-group
                        :class="{
                          borderColorFilter: lte !== null ? true : false,
                        }"
                      >
                        <b-form-datepicker
                          id="datepicker-to-date"
                          v-model="lte"
                          size="sm"
                          calendar-width="100%"
                          placeholder="Select"
                          @context="onContext"
                          :class="{ singleOptions: true }"
                          @input="onChangeToDate($event)"
                          :date-format-options="{
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                          }"
                        ></b-form-datepicker>
                        <template v-slot:append>
                          <button
                            class="filter-cross-btn"
                            @click="removeToDate()"
                          >
                            x
                          </button>
                        </template>
                      </b-input-group>
                    </div>
          
                    <div class="col-md-3 mb-3">
                      <label
                        for="car-make"
                        class="form-label text-muted filter-label-heading mt-3"
                        >Car Make</label
                      >
                      <multiselect
                        v-model="makeId"
                        :options="vehicleMakes"
                        option-label="name"
                        option-key="id"
                        name="makeName"
                        value="id"
                        :class="{
                          borderColorFilter: makeId !== null ? true : false,
                          singleOptions: true,
                        }"
                        :show-labels="false"
                        :custom-label="getCustomDescription"
                        @input="onChangeCarMake($event)"
                      >
                        <template slot="clear" slot-scope="props">
                          <span class="custom__tag custom-cross-btn">
                            <span
                              class="custom__remove"
                              v-if="makeId !== null"
                              @click="removeCarMake(props)"
                              >x</span
                            >
                          </span>
                        </template>
                      </multiselect>
                    </div>

                    <div class="col-md-2">
                      <label
                        for="car-make"
                        class="form-label filter-label-heading text-muted text-uppercase mt-3"
                        >Quoted
                      </label>

                      <multiselect
                        v-model="checkedIsQuoted"
                        :options="quotedArray"
                        placeholder="Select"
                        @select="onChangeIsQuoted"
                        @remove="removeIsQuoted($event)"
                        :show-labels="false"
                        :allow-empty="false"
                        :class="{
                          borderColorFilter: isQuoted !== null ? true : false || checkedIsQuoted !== 'Select',
                          singleOptions: true,
                        }"
                        :disabled="filterIsQuoted !== null"
                      >
                      </multiselect>
                    </div>

                    <div class="col-md-2">
                      <label
                        class="form-label filter-label-heading text-muted mt-3"
                        >Is Fully Quoted
                      </label>

                      <multiselect
                        v-model="checkedIsFullyQuoted"
                        :options="quotedArray"
                        placeholder="Select"
                        @select="onChangeIsFullyQuoted"
                        @remove="removeIsFullyQuoted($event)"
                        :show-labels="false"
                        :allow-empty="false"
                        :class="{
                          borderColorFilter: isFullyQuoted !== null ? true : false || checkedIsFullyQuoted !== 'Select',
                          singleOptions: true,
                        }"
                        :disabled="filterIsFullyQuoted !== null || filterIsQuoted !== null"
                      >
                      </multiselect>
                    </div>

                     <div class="col-md-2">
                      <label
                        for="is-walk-in"
                        class="form-label filter-label-heading text-muted mt-3"
                        >Has Order
                      </label>
                      <multiselect
                        v-model="checkedHasOrder"
                        :options="quotedArray"
                        placeholder="Select"
                        @select="onChangeHasOrder"
                        @remove="removeHasOrder($event)"
                        :show-labels="false"
                        :allow-empty="false"
                        :class="{
                          borderColorFilter: hasOrder !== null ? true : false,
                          singleOptions: true,
                        }"
                      >
                      </multiselect>
                    </div>
                  </div>
                </transition>

                <div id="load-spinner">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <div class="table-responsive table-zoom" id="rfp-table">
                  <table class="table data-table mb-0 table-rfp">
                    <thead class="table-color-heading">
                      <tr class="">
                        <th scope="col">View</th>
                        <th scope="col">RFP</th>
                        <th scope="col">Car</th>
                        <th scope="col">Car Vin</th>
                        <th scope="col">Order</th>
                        <th scope="col">Is Fully Quoted</th>
                        <th scope="col">Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="white-space-no-wrap transition-row"
                        v-for="rfpGrp in dashboardRFPGroups.edges"
                        :key="rfpGrp.id"
                      >
                        <td>
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <router-link
                              :to="'rfp/' + rfpGrp.node.number"
                              class="click-area-extend"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="text-secondary"
                                width="20"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                            </router-link>
                          </div>
                        </td>
                        <td class="table-font">
                          <div title="Click To Copy">
                            <div
                              @click.prevent="copyIdToClipboard(rfpGrp.node.id)"
                              class="rfp-id"
                            >
                              {{ rfpGrp.node.id }}
                            </div>
                          </div>
                        </td>
                        <td class="table-font">
                          <div class="data-content">
                            {{
                              rfpGrp.node.car.model.make.name +
                              " " +
                              rfpGrp.node.car.model.name
                            }}
                          </div>
                        </td>
                         <td class="table-font">
                          <div class="data-content">
                            {{
                              rfpGrp.node.car.vin ? rfpGrp.node.car.vin : ' - '
                            }}
                          </div>
                        </td>
                        <td class="table-font">
                          <div title="Click To Copy">
                            <div
                              v-if="rfpGrp.node.order"
                              @click.prevent="
                                copyIdToClipboard(rfpGrp.node.order.number)
                              "
                              class="rfp-id"
                            >
                              {{ rfpGrp.node.order.number }}
                            </div>
                            <div v-else>
                              -
                            </div>
                          </div>
                        </td>
                          <td
                          class="table-font"
                          style="text-align: center"
                          v-if="rfpGrp.node.isFullyQuoted === false"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="red"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z"
                            />
                          </svg>
                        </td>
                           <td v-else style="text-align: center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="green"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z"
                            />
                          </svg>
                        </td>
                         <td class="table-font">
                          <div class="data-content" :title="rfpGrp.node.createdAt">
                            {{
                              rfpGrp.node.createdAt | DateTimeFormat
                            }}
                          </div>
                        </td>

                      </tr>
                      <tr v-if="totalRows === 0">
                        <td colspan="6" align="center">No data found</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="p-3 row" id="page-bottom">
                  <div class="col-sm-12 col-md-6 d-flex align-items-center">
                    <div>
                      Total Enquiries: <b>{{ totalRows }}</b>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-6 d-flex justify-content-end">
                    <pagination
                      :currentPage="currentPage"
                      :perPage="perPage"
                      :totalRows="totalRows"
                      @changePage="handlePageChange"
                    ></pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from "../../../components/filters/search.vue";
import pagination from "../../../components/pagination/pagination.vue";
import sortingText from "../../../components/filters/sorting.vue";
import {
  GET_CAR_MAKE,
  PARTS_ENQUIRY_GROUPS_LIST
} from "../../../graphql/query";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { pagination, search, sortingText },
  name: "RFP",
    props: {
    titleText: {
      type: String,
      default: "Orders",
    },
    filterIsQuoted: {
      type: Boolean,
      default: null,
    },
    filterIsFullyQuoted: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
  
      sortingData: [
        { id: "CREATED_AT - ASC", name: "Created At - Asc." },
        { id: "CREATED_AT - DESC", name: "Created At - Desc." },
      ],
      sorting: { id: "CREATED_AT - DESC", name: "Created At - Desc." },
      showFilters: false,
      dashboardRFPGroups: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      after: null,
      before: null,
      hasNextPage: true,
      hasPreviousPage: false,
      last: null,
      first: null,
      search: null,
      searchText: null,
      direction: "",
      field: "",
      gte: null,
      lte: null,

      vehicleMakes: [],
      makeId: null,
      carMake: null,

      resetSvg: require("../../../assets/images/svg/reset.svg"),
      countFilter: 0,
      checkedIsFullyQuoted: "Select",

      quotedArray: ["Select", "True", "False"],
      isFullyQuoted: null,
      hasOrder: null,
      checkedHasOrder: null,
      rfpFilters: {
        filter_date_lte: null,
        filter_date_gte: null,
        carMake: null,
        isFullyQuoted: null,
        hasOrder: null,
        isQuoted: null,

      },
      rfpSearch: null,
      checkedIsQuoted: "Select",
      isQuoted: null,
    };
  },
  apollo: {
    vehicleMakes: {
      query: GET_CAR_MAKE,
    },
  },
  computed: {
    ...mapGetters({
      stateRFPFilters: "rfpFilters",
      stateSearch: "rfpSearch",
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      if (
        from.name !== "rfp-view" &&
        from.name !== "rfp-add" &&
        from.name !== null
      ) {
        vm.rfpSearch = null;
        vm.changeSearch(vm.rfpSearch);
      }
    });
  },
  watch: {
    rfpFilters: function () {
      this.changeRFPFilters(this.rfpFilters);
    },
    rfpSearch: function () {
      this.changeSearch(this.rfpSearch);
    },
     titleText: function () {
      this.after = null;
      this.before = null;
      this.first = this.perPage;
      this.last = null;
      this.currentPage = 1;
      this.changeRFPFilters(this.rfpFilters);
      // if (this.filterHasApprovedQuotation) {
      //   this.direction = "DESC";
      //   this.field = "APPROVED_QUOTATION_AT";
      //   this.sorting.id = "APPROVED_QUOTATION_AT - DESC";
      //   this.sorting.name = "Approved Quotation At - Desc." ;
      // } 
      // else if (this.filterIsLPOReceived) {
      //   this.direction = "DESC";
      //   this.field = "LPO_RECEIVED_AT";
      //   this.sorting.id = "LPO_RECEIVED_AT - DESC";
      //   this.sorting.name = "LPO Received At - Desc." ;
      // } 
      // else {
      //   this.direction = "DESC";
      //   this.field = "SCHEDULED_AT";
      //   this.sorting.id = "SCHEDULED_AT - DESC";
      //   this.sorting.name = "Scheduled At - Desc." ;
      // }
      this.getRFP();
    },  
    filterIsQuoted: {
      handler(newVal) {
        if (newVal === true) {
          this.checkedIsQuoted = "True";
        } else if (newVal === false) {
          this.checkedIsQuoted = "False";
        } else {
          this.checkedIsQuoted = "Select";
        }
      },
      immediate: true,
    },
    filterIsFullyQuoted: {
      handler(newVal) {
        if (newVal === true) {
          this.checkedIsFullyQuoted = "True";
        } else if (newVal === false) {
          this.checkedIsFullyQuoted = "False";
        } else {
          this.checkedIsFullyQuoted = "Select";
        }
      },
      immediate: true,
    },
  },
  
  async created() {
    (this.direction = "DESC"), (this.field = "CREATED_AT");
    this.countFilter = 0;

    this.rfpFilters = this.stateRFPFilters;
    this.changeRFPFilters(this.rfpFilters);
    var value = JSON.parse(localStorage.getItem("vuex"));
    value = value.rfpFilters;
    value.sort_by = this.field + " - " + this.direction;

    if (localStorage.getItem("vuex") !== null) {
      this.first = this.perPage;
      this.getLocalStorage();
      this.getRFP();
    } else {
      this.countFilter = 0;
      this.first = this.perPage;
      this.getLocalStorage();
      this.getRFP();
    }
  },
  methods: {
    ...mapActions({
      rfpFilterChange: "rfpFilterAction",
      searchChange: "searchAction",
    }),
    filterClick() {
      this.countFilter = document.querySelectorAll(".borderColorFilter").length;
    },

    getLocalStorage() {
      this.countFilter = 0;
      var value = JSON.parse(localStorage.getItem("vuex"));
      value = value.rfpFilters;
      if (value) {
        if (
          value.filter_date_lte !== null ||
          value.filter_date_gte !== null ||
          value.carMake !== null ||
          value.isFullyQuoted !== null ||
          value.hasOrder !==null||
          value.rfpSearch !== null ||
          value.isQuoted !== null
        ) {
          this.showFilters = true;
      

          if (value.filter_date_lte) {
            this.lte = value.filter_date_lte;
            this.countFilter += 1;
          }

          if (value.filter_date_gte) {
            this.gte = value.filter_date_gte;
            this.countFilter += 1;
          }

          if (value.carMake) {
            this.makeId = value.carMake;
            this.countFilter += 1;
          } else {
            this.makeId = null;
          }


          if (value.isQuoted === 'True') {
            this.checkedIsQuoted = "True";
            this.isQuoted = true;
            this.countFilter += 1;
          } else if (value.isQuoted === 'False') {
            this.checkedIsQuoted = "False";
            this.isQuoted = false;
            this.countFilter += 1;
          } else {
            this.checkedIsQuoted = "";
            this.isQuoted = null;
          }

          if(value.isFullyQuoted === 'True'){
              this.checkedIsFullyQuoted = 'True';
              this.isFullyQuoted = true;
              this.countFilter += 1;
          }
          else if(value.isFullyQuoted === 'False'){
            this.checkedIsFullyQuoted = 'False';
            this.isFullyQuoted = false;
            this.countFilter += 1;
          }
          else{
            this.checkedIsFullyQuoted = "";
            this.isFullyQuoted = null;
          }

          
          if(value.hasOrder === 'True'){
              this.checkedHasOrder = 'True';
              this.hasOrder = 'True';
              this.countFilter += 1;
          }
          else if(value.hasOrder === 'False'){
            this.checkedHasOrder = 'False';
            this.hasOrder = 'False';
            this.countFilter += 1;
          }
          else{
            this.checkedHasOrder = null;
            this.hasOrder = null;
          }
       
          this.showFilters = false;
        } else {
          this.showFilters = false;
        }
      }
    },

    changeRFPFilters(value) {
      this.countFilter = 0;
      this.rfpFilterChange({ rfpFilters: value });
    },

    changeSearch(value) {
      // this.countFilter = 0;
      this.searchChange({ rfpSearch: value });
      if (this.rfpSearch) {
        this.search = this.rfpSearch;
      }
    },

   async getRFP() {
  await this.$nextTick(); // ensure DOM is ready

  const rfpTable = document.getElementById("rfp-table");
  const pageBottom = document.getElementById("page-bottom");
  const loadSpinner = document.getElementById("load-spinner");

  if (rfpTable && pageBottom && loadSpinner) {
    rfpTable.style.display = "none";
    pageBottom.style.display = "none";
    loadSpinner.style.display = "flex";
  }

  let search = this.search && /^[\d\s+]+$/.test(this.search)
    ? this.search.replace(/\s/g, "").replace(/^0+/, "")
    : this.search;

  try {
    const { data } = await this.$apollo.query({
      query: PARTS_ENQUIRY_GROUPS_LIST,
      variables: {
        first: this.first,
        after: this.after,
        before: this.before,
        search: search,
        direction: this.direction,
        field: this.field,
        gte: this.gte,
        lte: this.lte,
        last: this.last,
        isQuoted:
          this.filterIsQuoted !== null
            ? this.filterIsQuoted
            : this.isQuoted == null
            ? null
            : this.isQuoted == "True",
        isFullyQuoted:
          this.filterIsFullyQuoted !== null
            ? this.filterIsFullyQuoted
            : this.isFullyQuoted == null
            ? null
            : this.isFullyQuoted == "True",
        carMake: this.makeId ? this.makeId.id : null,
        hasOrder:
          this.hasOrder == null
            ? null
            : this.hasOrder == "True",
      },
    });

    await this.$nextTick(); // ensure reactivity updates before showing DOM again

    if (loadSpinner && rfpTable && pageBottom) {
      loadSpinner.style.display = "none";
      rfpTable.style.display = "block";
      pageBottom.style.display = "flex";
    }

    this.dashboardRFPGroups = data.workshopEnquiryGroups;
    this.totalRows = data.workshopEnquiryGroups.totalCount;
    this.after = data.workshopEnquiryGroups.pageInfo.endCursor;
    this.before = data.workshopEnquiryGroups.pageInfo.startCursor;
    this.hasNextPage = data.workshopEnquiryGroups.pageInfo.hasNextPage;
    this.hasPreviousPage = data.workshopEnquiryGroups.pageInfo.hasPreviousPage;

  } catch (error) {
    console.error("Error fetching RFP:", error);
    if (loadSpinner) loadSpinner.style.display = "none";
  }
},


    async onChangeCarMake(selection) {
      if (selection == null) {
        this.modelId = null;
      } else {
        this.makeId = selection;
        this.after = null;
        this.before = null;
        this.last = null;
        this.first = this.perPage;
        this.currentPage = 1;
        this.rfpFilters.carMake = selection;
        this.changeRFPFilters(this.rfpFilters);
        this.getRFP();
      }
    },
    removeCarMake(selectedOption) {
      if (selectedOption) {
        this.makeId = null;
        this.before = null;
        this.after = null;
        this.last = null;
        this.first = this.perPage;
        this.currentPage = 1;
        this.rfpFilters.carMake = null;
        this.changeRFPFilters(this.rfpFilters);
        this.getRFP();
      }
    },
    getCustomDescription(opt) {
      return opt.name;
    },

    onChangeIsQuoted(event) {
      if (event === "Select") {
        this.isQuoted = null;
        this.rfpFilters.isQuoted = null;
      } else {
        this.isQuoted = event;
        this.rfpFilters.isQuoted = event;
      }
      this.after = null;
      this.before = null;
      this.first = this.perPage;
      this.last = null;
      this.currentPage = 1;
      this.changeRFPFilters(this.rfpFilters);
      this.getRFP();
    },

    removeIsQuoted(selectedOption) {
      if (selectedOption) {
        this.isQuoted = null;
        this.rfpFilters.isQuoted = null;
        this.before = null;
        this.after = null;
        this.last = null;
        this.first = this.perPage;
        this.currentPage = 1;
        this.changeRFPFilters(this.rfpFilters);
        this.getRFP();
      }
    },

    onChangeIsFullyQuoted(event) {
    if (event === "Select") {
      this.isFullyQuoted = null;
      this.rfpFilters.isFullyQuoted = null;
    } else {
      this.isFullyQuoted = event;
      this.rfpFilters.isFullyQuoted = event;
    }
    this.after = null;
    this.before = null;
    this.first = this.perPage;
    this.last = null;
    this.currentPage = 1;
    this.changeRFPFilters(this.rfpFilters);
    this.getRFP();
    },
    removeIsFullyQuoted(selectedOption) {
      if (selectedOption) {
        this.isFullyQuoted = null;
        this.rfpFilters.isFullyQuoted = null;
        this.before = null;
        this.after = null;
        this.last = null;
        this.first = this.perPage;
        this.currentPage = 1;
        this.changeRFPFilters(this.rfpFilters);
        this.getRFP();
      }
    },

    onChangeHasOrder(event) {
    if (event === "Select") {
      this.hasOrder = null;
      this.rfpFilters.hasOrder = null;
    } else {
      this.hasOrder = event;
      this.rfpFilters.hasOrder = event;
    }
    this.after = null;
    this.before = null;
    this.first = this.perPage;
    this.last = null;
    this.currentPage = 1;
    this.changeRFPFilters(this.rfpFilters);
    this.getRFP();
    },
    removeHasOrder(selectedOption) {
      if (selectedOption) {
        this.hasOrder = null;
        this.rfpFilters.hasOrder = null;
        this.before = null;
        this.after = null;
        this.last = null;
        this.first = this.perPage;
        this.currentPage = 1;
        this.changeRFPFilters(this.rfpFilters);
        this.getRFP();
      }
    },

    handlePageChange(event) {
      if (event > this.currentPage && this.hasNextPage) {
        this.currentPage = event;
        this.before = null;
        this.last = null;
        this.first = this.perPage;
        this.after;
        this.getRFP();
      } else if (event < this.currentPage && this.hasPreviousPage) {
        this.currentPage = event;
        this.after = null;
        this.before;
        this.last = this.perPage;
        this.first = null;
        this.getRFP();
      }
    },
    handleSearchRFP(event) {
      this.search = event;
      this.after = null;
      this.before = null;
      this.last = null;
      this.first = this.perPage;
      this.currentPage = 1;
      this.rfpSearch = event;
      this.changeSearch(this.rfpSearch);
      this.getRFP();
    },

    onChangeSorting(event) {
      if (event.id === null) {
        this.field = "CREATED_AT";
        this.direction = "DESC";
        this.before = null;
        this.after = null;
        this.currentPage = 1;
        this.last = null;
        this.first = this.perPage;
        this.getRFP();
      } else {
        var res = event.id.split("-");
        this.field = res[0].replaceAll(" ", "");
        this.direction = res[1].replaceAll(" ", "");
        this.before = null;
        this.after = null;
        this.last = null;
        this.first = this.perPage;
        this.currentPage = 1;
        this.getRFP();
      }
    },
    onContext(ctx) {
      this.nextServiceDue = ctx.selectedYMD;
    },
    onChangeFromDate(event) {
      this.gte = event;
      this.rfpFilters.filter_date_gte = event;
      this.after = null;
      this.before = null;
      this.currentPage = 1;
      this.last = null;
      this.first = this.perPage;
      this.changeRFPFilters(this.rfpFilters);
      this.getRFP();
    },
    onChangeToDate(event) {
      this.lte = event;
      this.rfpFilters.filter_date_lte = event;
      this.after = null;
      this.before = null;
      this.last = null;
      this.first = this.perPage;
      this.currentPage = 1;
      this.changeRFPFilters(this.rfpFilters);
      this.getRFP();
    },
    removeFromDate() {
      this.gte = null;
      this.after = null;
      this.before = null;
      this.currentPage = 1;
      this.last = null;
      this.first = this.perPage;
      this.rfpFilters.filter_date_gte = null;
      this.changeRFPFilters(this.rfpFilters);
      this.getRFP();
    },
    removeToDate() {
      this.lte = null;
      this.after = null;
      this.before = null;
      this.currentPage = 1;
      this.last = null;
      this.first = this.perPage;
      this.rfpFilters.filter_date_lte = null;
      this.changeRFPFilters(this.rfpFilters);
      this.getRFP();
    },

    resetFilters() {
      this.currentPage = 1;
      this.after = null;
      this.before = null;
      this.first = this.perPage;
      (this.last = null),
      (this.sorting = null),
      (this.status = null),
      (this.direction = "DESC"),
      (this.field = "CREATED_AT"),
      (this.gte = null);
      this.lte = null;
      this.countFilter = 0;
  
      this.makeId = null;
      this.checkedIsFullyQuoted = null;
      this.checkedHasOrder = null;
      this.isFullyQuoted = null;
      this.hasOrder = null;
      this.checkedIsQuoted = null;
      this.isQuoted = null;

      this.rfpFilters.isQuoted = null;
      this.rfpFilters.filter_date_gte = null;
      this.rfpFilters.filter_date_lte = null;
      this.rfpFilters.carMake = null;
      this.rfpFilters.isFullyQuoted = null;
      this.rfpFilters.hasOrder = null;

      this.changeRFPFilters(this.rfpFilters);
      this.getRFP();
    },
    copyIdToClipboard(id) {
      // Create a temporary input element
      var input = document.createElement('textarea');
      input.value = id.trim(); // Remove leading/trailing spaces
      document.body.appendChild(input);

      // Select the text within the input
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices

      // Copy the selected text to the clipboard
      document.execCommand('copy');

      // Clean up by removing the input element
      document.body.removeChild(input);

      var message = "Copied";
      this.$bvToast.toast(id + " " + `${message}`, {
        toaster: "b-toaster-top-center",
        variant: "success",
        solid: true,
        toastClass: "text-center toast-box toast-style",
      });
    },
  },
};
</script>

<style>
.filter-btn {
  font-size: 1.1rem !important;
}
.display-search .search-input {
  margin-top: 45px;
}

.search-css {
  color: #757981;
  font-size: small;
  padding: 5px;
}
table.table-rfp {
  text-align: center;
}
.singleOptions .multiselect__tags {
  min-height: 47px;
}
.transition-row {
  transition: transform 0.1s;
}
.transition-row:hover {
  background-color: rgb(245, 245, 245);
  /* transform: scale(0.99); */
}
.click-area-extend {
  padding: 0.25rem 1rem 0.25rem 1rem;
  cursor: pointer;
}
.toast-style {
  font-size: 1.2rem;
  padding: 1rem;
}
.rfp-id:hover {
  color: blue;
  cursor: pointer;
}
.text-area-clipboard {
  border: none;
  color: white;
  height: 0;
  width: 0;
}
.table-zoom {
  zoom: 90%;
}
.white-space {
  overflow: auto;
  white-space: nowrap;
}

.card-body-2 {
  padding: 10px 20px 20px 20px;
}
.sorting-div .singleOptions .multiselect__tags {
  min-height: 10px !important;
}

.singleOptions .multiselect__tags {
  min-height: 37px !important;
}

.custom-cross-btn {
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  top: 40%;
  right: 14%;
  z-index: 1;
  transform: translate(0%, -50%);
}
.multiselect {
  min-height: 10px !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 13px !important;
}

.multiselect__input,
.multiselect__single {
  min-height: 12px !important;
  line-height: 14px !important;
}

.multiselect__tag {
  position: relative;
  display: inline-block;
  /* display: inline-table; */
  padding: 4px 26px 4px 10px;
  border-radius: 5px;
  margin-right: 10px;
  color: #fff;
  line-height: 1;
  background: #41b883;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}

.multiselect__select {
  height: 31px !important;
}
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}

.multOptions .multiselect__tags {
  /* height: 72px; */
  height: 55px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.filter-cross-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  padding: 0 0.75rem 0 0.75em;
  border-radius: 0.25rem;
}

.b-form-btn-label-control.form-control > .form-control.form-control-sm {
  overflow: auto !important;
  white-space: nowrap !important;
}
.reset-btn-padding {
  padding: 0.2rem;
}

.reset-btn-padding-onlist {
  padding: 0.4rem;
}

.notify .badge {
  background: radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -moz-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -ms-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -o-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -webkit-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background-color: #ed2324;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  padding: 5% 5%;
  float: right;
  display: block;
  position: relative;
  top: -16px;
  left: 12px;
}

.customMultiSelect-div {
  max-width: 22.2%;
  flex: 0 0 22.2%;
}

.message-count {
  position: relative;
  display: block;
  font: bold 14px/13px Helvetica, Verdana, Tahoma;
  text-align: center;
  margin: 0;
  top: 2px;
}

#rfp-container .borderColorFilter {
  /* background-color: gray; */
  border: 2px solid #9a18ffd1 !important;
  border-radius: 5px;
}

#rfp-container .filter-tabs.col-md-3,
#rfp-container .filter-tabs.col-md-2 {
  flex: 0 0 20%;
  max-width: 20%;
}

#rfp-container .borderColorFilter.is-true {
  border: none !important;
}

#rfp-container
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #3378ff;
  border-color: #3378ff;
  border: 2px solid #9a18ffd1 !important;
  border-radius: 10px;
}

#load-spinner {
  justify-content: center;
  display: none;
}

@media only screen and (max-width: 768px) {
  .table th,
  .table td {
    padding: 10px 5px;
  }

  #rfp-container .filter-tabs.col-md-3,
  #rfp-container .filter-tabs.col-md-2 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .display-search .search-input {
    margin-top: 0px;
  }
}

@media only screen and (max-width: 470px) {
}

@media only screen and (max-width: 417px) {
  .sorting-div {
    margin-bottom: 1rem;
  }
  .display-search.d-flex {
    display: block !important;
  }
  .display-search .btn {
    width: 50%;
  }
  /* .mobile-align-rfp {
    justify-content: flex-start;
  } */
  .filter-div {
    margin-left: 0rem !important;
  }
}
</style>

